import { useTranslation } from 'next-i18next';
import { type WebsiteData } from '@/api/ai/website/types';
import { type AiLoadingState } from './aiLoadingMessages.const';
import { AiGeneratingPending } from './Base';
type Props = {
  websiteData?: WebsiteData;
  loadingState: Omit<AiLoadingState, 'sourceType'>;
};
export const AiGeneratingPendingByWebsite = ({
  websiteData,
  loadingState
}: Props) => {
  const {
    t
  } = useTranslation(['build']);
  return <AiGeneratingPending imageSrc={'/assets/ai_generating_v2.webp'} prompt={websiteData?.title ? t('build:build.website.pending.generatingMessage', {
    title: websiteData.title
  }) : undefined} loadingState={{
    ...loadingState,
    sourceType: 'website'
  }} data-sentry-element="AiGeneratingPending" data-sentry-component="AiGeneratingPendingByWebsite" data-sentry-source-file="AiGeneratingPendingByWebsite.tsx" />;
};